module.exports = __webpack_public_path__ + "img/video-jp-1.fcb994b.jpg";